import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeCompanyModal, requestDeletePaymentMethod } from '../../../../../redux/actions/company'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { Popup } from '../../../../library/popup'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const modalState = useSelector(state => state.company.showModals.removePaymentMethod)
    const memberId = useSelector(state => state.company.activeEdit?.id)
    const companyId = useSelector(state => state.company?.details?.id)

	const loading = useSelector(state => state.company?.deletePaymentMethod.loading)
    const methodId = useSelector(state => state.company.activePaymentMethod.id)

    const handleClose = () => {
        dispatch(changeCompanyModal({removePaymentMethod: false}))
    }

    const clickRemovePaymentMethod = () => {
        dispatch(requestDeletePaymentMethod({methodId: methodId}))
    }

    return(
        <Popup
            onClose={handleClose}
            show={modalState} 
            title="Vil du fjerne betalingsmetoden?"
            description="Hvis du fjerner denne betalingsmetoden og ikke har noen andre lagt inn før neste månedlige betaling kan du risikere å miste det aktive abonnementet ditt."
            buttons={[
                <TransparentButton title="Avbryt" id="closeButtonAdd" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
                <SolidButton color="red" title={loading ? "Sletter..":"Ja, fjern betalingsmetode"} icon={loading ? <i className="fas fa-circle-notch fa-spin"></i>:null} onClick={() => clickRemovePaymentMethod()} type="button"/>
            ]}	
        />
    )
}

export default Index
